<script lang="ts">
  import { onMount } from 'svelte';
  import { anim } from './lib/anim/settings.svelte';
  import Animate from './lib/components/Animate.svelte';
  import Header from './lib/components/Header.svelte';
  import SceneEditor from './lib/components/scene/SceneEditor.svelte';
  import Admin from './lib/components/Admin.svelte';
  import Gallery from './lib/components/Gallery.svelte';
  import { caps } from './lib/config.svelte';
  import Studio from './lib/components/Studio.svelte';
  import { loadCapabilities } from './lib/config.svelte';
  import { locale, t } from './lib/i18n/index.svelte';
  import { studio } from './lib/state.svelte';
  import { ui, type View } from './lib/ui.svelte';

  const views = $derived([
    { id: 'studio' as View, label: t('nav.studio') },
    { id: 'animate' as View, label: t('nav.animate') },
    { id: 'scene' as View, label: t('nav.scene') },
    ...(caps.gallery ? [{ id: 'gallery' as View, label: t('nav.gallery') }] : []),
  ]);
  const isAdmin = typeof location !== 'undefined' && location.pathname.replace(/\/+$/, '') === '/admin';

  $effect(() => {
    // The gallery may be switched off while open.
    if (ui.view === 'gallery' && caps.loaded && !caps.gallery) ui.view = 'studio';
  });

  onMount(() => {
    document.documentElement.lang = locale();
    loadCapabilities();
  });

  function useScene(target: 'studio' | 'animate') {
    if (target === 'studio') studio.sourceKind = 'scene';
    else anim.source = 'scene';
    ui.view = target;
  }
</script>

{#if isAdmin}
  <Admin />
{:else}
  <div class="app">
    <Header bind:view={ui.view} {views} />
    <div class="content">
      {#if ui.view === 'studio'}
        <Studio />
      {:else if ui.view === 'animate'}
        <Animate />
      {:else if ui.view === 'scene'}
        <SceneEditor onuse={useScene} />
      {:else if ui.view === 'gallery'}
        <Gallery />
      {/if}
    </div>
  </div>
{/if}

<style>
  .app {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .content {
    flex: 1;
    min-height: 0;
  }
</style>
